<template>
  <section class="app-main" :style="[hiddenSidebarStyle]">
    <loading :active="loadingActive" :settings="loaderSettings"></loading>
    <div class="container is-fluid fct-fluid is-marginless app-content" :class="{'scroll-locked': loadingCount}">
      <levelbar v-if="$auth.check()" style="z-index: 300"></levelbar>
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear>
        <div class="fct-box-mobile overflowed">
          <router-view class="animated"></router-view>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
  import Levelbar from './Levelbar'
  import {mapGetters} from 'vuex'
  import EventBus from './EventBus'

  export default {
    data () {
      return {
        loadingCount: 0,
        loaderSettings: {}
      }
    },
    computed: {
      ...mapGetters({
        sidebar: 'sidebar',
      }),
      hiddenSidebarStyle() {
        return this.sidebar.hidden ? {'margin-left': 0} : null
      },
      loadingActive() {
        return !!this.loadingCount && this.$auth.check()
      }
    },
    components: {
      Levelbar
    },
    mounted () {
      EventBus.$on('start-loading', ({settings} = {}) => {
        this.loaderSettings = settings
        this.loadingCount++
      })
      EventBus.$on('stop-loading', (params) => {
        if (this.loadingCount > 0) {
          return this.loadingCount--
        }

        console.warn("stop loading emitted too many times")
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/derived-variables';
  @import '~bulma/sass/utilities/mixins';


  @include tablet () {
    .overflowed {
      width: 100%;
      float: right; // solved problem of margin for overflowed elements
    }

    .is-full-page, .modal {
      left: 0 !important;
      top: 0;
      bottom: 0;
      right: 0;

      &.include-sidebar {
        left: 250px !important;
        width: calc(100vw - 250px);
      }
    }

    .vld-overlay.is-full-page {
      height: 100vh;
    }
  }

  @include mobile () {
    .is-full-page, model {
      top: 50px;
      max-height: calc(100vh - 50px);

      &.include-sidebar {
        top: 0 !important;
        max-height: 100vh;
      }
    }
  }

  .app-main {
    position: relative;
    /*padding-top: 50px;*/
    /*margin-left: 280px;*/

    transform: translate3d(0, 0, 0);

    .app-content {
      overflow-y: auto;
      max-height: 100vh;

      &.scroll-locked {
        //max-height: 100vh;
        overflow-y: hidden;

        @include mobile() {
          max-height: calc(100vh - 50px)
        }
      }
      background-color: #FAFCFB !important;
      padding: 45px 45px 45px;
      position: fixed;
      right: 0;
      width: calc(100vw - 250px);



      @include mobile () {
        position: relative;
        width: 100%;
        padding: 0;
      }

      min-height: 100vh;
    }

    @include mobile() {
      margin-left: 0;
    }
  }

  @media screen and (min-width: 1000px) {
    .container.fct-fluid {
      margin: 0 20px;
      max-width: none !important;
    }
  }


</style>
